<template>
  <entity-edit-form
    :title="title"
    :data-service="dataService"
    :create-entity="true"
    :fields="fields"
    :list-route-name="listRouteName"
  />
</template>

<script>
  import EntityEditForm from '@/components/ui/crud/EntityEditForm.vue'
  import FaktLegalEntityDataService from '@/services/api/FaktLegalEntityDataService'
  import RouteName from '@/models/enums/RouteName'
  import { faktLegalEntityFields } from './faktLegalEntityFields'

  export default {
    name: 'FaktLegalEntityCreate',
    components: { EntityEditForm },
    data () {
      return {
        title: 'Новое юрлицо FAKT',
        listRouteName: RouteName.AdministrationFaktLegalEntities,
        dataService: FaktLegalEntityDataService,
        fields: faktLegalEntityFields({ isCreate: true }),
      }
    },
  }
</script>
